import type { IPaginationAndSearchParams } from "@/shared/api/search-params"

export const energyPassportQueryKeys = {
  all: ["energy-passport"] as const,
  lists: () => [...energyPassportQueryKeys.all, "list"] as const,
  list: (filters?: IPaginationAndSearchParams) => [...energyPassportQueryKeys.lists(), { filters: JSON.stringify(filters) }] as const,
  infinite: (params?: object) => [...energyPassportQueryKeys.lists(), { params }] as const,
  details: () => [...energyPassportQueryKeys.all, "detail"] as const,
  detail: (id?: string) => [...energyPassportQueryKeys.details(), id] as const
}
